export default __webpack_public_path__ + "static/FoundersGrotesk-Regular-44f7df1c9a8695f9ba791b1aa2daad65.otf";